import { find, map } from 'lodash';
import { epoch, utc } from '../../util/datetime';
import { SubscriptionType } from './Subscription.enum';
import type { ISubscription } from './Subscription.interface';
import SubscriptionDetails from './SubscriptionDetails';

export default class Subscription implements ISubscription {
  id: string;
  email: string;
  created: number;
  delinquent: boolean;
  description: string;
  sources: Array<any>;
  subscriptions: Array<SubscriptionDetails>;

  hasSubscription() {
    return !!this.getSubscription();
  }

  hasSubscriptionBrokers() {
    return !!this.getSubscriptionBrokers();
  }

  hasSubscriptionWebloanQ() {
    return !!this.getSubscriptionWebloanQ();
  }

  hasSubscriptionPartners() {
    return !!this.getSubscriptionPartners();
  }

  hasSubscriptionPhones() {
    return !!this.getSubscriptionPhones();
  }

  getSubscription() {
    return find(
      this.subscriptions,
      (obj) =>
        obj.type === SubscriptionType.MBROKERS ||
        obj.type === SubscriptionType.SUBCRM ||
        obj.type === SubscriptionType.SUBPROCESSOR ||
        obj.type === SubscriptionType.WEBLOANQ ||
        obj.type === SubscriptionType.PROMNT ||
        obj.type === SubscriptionType.PROANN ||
        obj.type === SubscriptionType.BUSMNT ||
        obj.type === SubscriptionType.BUSANN
    );
  }

  getSubscriptionBrokers() {
    return find(this.subscriptions, (obj) => obj.type === SubscriptionType.MBROKERS);
  }

  getSubscriptionProcessors() {
    return find(this.subscriptions, (obj) => obj.type === SubscriptionType.SUBPROCESSOR);
  }

  getSubscriptionWebloanQ() {
    return find(this.subscriptions, (obj) => obj.type === SubscriptionType.WEBLOANQ);
  }

  getSubscriptionPartners() {
    return find(this.subscriptions, (obj) => obj.type === SubscriptionType.PARTNERS);
  }

  getSubscriptionPhones() {
    return find(this.subscriptions, (obj) => obj.type === SubscriptionType.PHONES);
  }

  static build = (data: ISubscription) => new Subscription(data);
  static blank = () => new Subscription();

  /**
   * Constructor
   * @param {ISubscription} data
   */
  constructor(data?: ISubscription) {
    this.id = data?.id || undefined;
    this.email = data?.email || undefined;
    this.created = epoch(utc(data?.created));
    this.delinquent = data?.delinquent === true;
    this.description = data?.description || undefined;
    this.sources = data?.sources || undefined;
    this.subscriptions = map(data?.subscriptions?.data, (obj) => new SubscriptionDetails(obj));
  }
}
